const filter = [
  {
    service: {
      folder: 'bibliotecas',
      file: 'Bibliotecas',
      relationship: ''
    },
    listLabel: 'biblioteca',
    label: 'Biblioteca',
    itemValue: 'id',
    itemText: 'apelido',
    id: 'biblioteca_id'
  }
]

export default filter
